<template>
  <b-card-code>
    <validation-observer ref="simpleRules">
      <b-form @submit.prevent="submitForm">
        <b-row>
          <b-col md="4">
            <b-form-group>
              <label>Job Vacancy</label>
              <label style="color: red !important">*</label>
              <validation-provider #default="{ errors }" rules="required" name="Job Vacancy">
                <v-select v-model="vacancyid" label="name" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  placeholder="None" :options="jobvacancyoption" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label>Name</label>
              <label style="color: red !important">*</label>
              <validation-provider #default="{ errors }" rules="required" name="Name">
                <b-form-input v-model="name" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  placeholder="Enter Name" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label>File</label>
              <label style="color: red !important">*</label>
              <validation-provider #default="{ errors }" rules="required" name="File">
                <b-form-file v-model="attachment" placeholder="Select File" drop-placeholder="Drop file here..."
                  accept="image/*" @input="handleFile($event, 'cv')" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <attachment :data="attachment" />
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label>Status</label>
              <label style="color: red !important">*</label>
              <validation-provider #default="{ errors }" rules="required" name="Status">
                <v-select v-model="status" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" label="name"
                  placeholder="None" :options="[
                    'Call for interview ',
                    'Not interested',
                    'Interview level1',
                    'Interview level2',
                    'Interview level3',
                    'Not selected',
                  ]" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label>At</label>
              <label style="color: red !important">*</label>
              <validation-provider #default="{ errors }" rules="required" name="At">
                <b-form-input v-model="at" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" placeholder="Enter At" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label>Taluka</label>
              <label style="color: red !important">*</label>
              <validation-provider #default="{ errors }" rules="required" name="Taluka">
                <b-form-input v-model="taluka" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  placeholder="Enter Taluka" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col md="4">
            <b-form-group>
              <label>Pin Code</label>
              <label style="color: red !important">*</label>
              <validation-provider #default="{ errors }" rules="required|digits:6" name="Pin Code">
                <b-form-input v-model="pincode" maxlength="6" @input="clickPincode($event)"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" type="number" placeholder="Enter Pin Code" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label>District</label>
              <label style="color: red !important">*</label>
              <validation-provider #default="{ errors }" rules="required" name="City">
                <v-select v-model="city" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="cityOption"
                  @input="clickArea($event)" label="City" placeholder="None" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label>Area</label>
              <label style="color: red !important">*</label>
              <validation-provider #default="{ errors }" rules="required" name="Area">
                <v-select v-model="area" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="areaOption"
                  placeholder="None" @input="handlePincode()" label="PostOfficeName" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label>State</label>
              <label style="color: red !important">*</label>
              <validation-provider #default="{ errors }" rules="required" name="State">
                <v-select v-model="state" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" placeholder="None"
                  :options="stateOptions" label="State" @input="handleCity()" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label>Mobile</label>
              <label style="color: red !important">*</label>
              <validation-provider #default="{ errors }" :rules="{ required: true, mobileDigits: true }" name="Mobile">
                <b-form-input v-model="phone" maxlength="10" @keypress="handleMobileKeypress($event)" @input="handleMobileInput($event)"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  placeholder="Enter Mobile" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label>Email</label>
              <label style="color: red !important">*</label>
              <validation-provider #default="{ errors }" rules="required|email" name="Email">
                <b-form-input v-model="email" type="email" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  placeholder="Enter Email" />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-button variant="primary" type="submit" @click.prevent="submitForm($event)" class="mr-4" :disabled="flag">
              Submit
            </b-button>
            <b-button variant="primary" @click="onClickBack">Back </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>

    <!-- <template #code>
      {{ codeType }}
    </template> -->
  </b-card-code>
</template>
<script>
import BCardCode from "@core/components/b-card-code";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import PinchScrollZoom from "@coddicat/vue-pinch-scroll-zoom";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import {
  BFormInput,
  BFormGroup,
  BForm,
  BRow,
  BInputGroupAppend,
  BCol,
  BInputGroup,
  BButton,
  BFormTextarea,
  BFormDatepicker,
  BImgLazy,
  BFormFile,
} from "bootstrap-vue";
import Attachment from "../../../components/Attechment.vue";
import {
  required,
  email,
  confirmed,
  url,
  between,
  alpha,
  integer,
  password,
  min,
  digits,
  alphaDash,
  length,
  min_value,
} from "@validations";
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import axios from '@/components/axios';
import moment from "moment";
import { extend } from "vee-validate";

export default {
  components: {
    PinchScrollZoom,
    Datepicker,
    BCardCode,
    ValidationProvider,
    ValidationObserver,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BButton,
    vSelect,
    BFormDatepicker,
    BFormTextarea,
    BImgLazy,
    BFormFile,
    Attachment,
  },
  data() {
    return {
      accessToken: localStorage.getItem("accessToken"),
      baseApi: process.env.VUE_APP_APIENDPOINT,
      vacancyid: "",
      jobvacancyoption: [],
      name: "",
      attachment: "",
      status: "",
      at: "",
      taluka: "",
      area: "",
      areaOption: [],
      StateData: [],
      stateOptions: [],
      city: "",
      cityOption: [],
      pincode: "",
      state: "",
      phone: "",
      email: "",
      ifEdit: "",
      accessToken: localStorage.getItem("accessToken"),
      baseApi: process.env.VUE_APP_APIENDPOINT,
      id: "",
      fromState: "",
      flag: false,
    };
  },
  mounted() {
    // Extend vee-validate with custom mobile digits rule
    extend('mobileDigits', {
      validate: (value) => {
        // If empty, don't show this error (required rule will handle it)
        if (!value || value === '' || value.length === 0) {
          return true;
        }
        // Only show error if value exists, has digits, but is not exactly 10 digits
        // This means user has entered a number but it's incomplete
        if (/^\d+$/.test(value)) {
          return value.length === 10;
        }
        // If contains non-digits, return false (but this shouldn't happen due to input restrictions)
        return false;
      },
      message: 'The Mobile field must be numeric and exactly contain 10 digits'
    });

    const userData = JSON.parse(localStorage.getItem("UserRights"));
    const role = JSON.parse(localStorage.getItem("userData")).role;
    if (role !== "admin") {
      userData.map((item) => {
        if (item.modulename == "Resume") {
          if (this.$route.params.id) {
            if (item.edit !== 1) {
              this.$router.push("/hr/resume");
            }
          } else if (item.add !== 1) {
            this.$router.push("/hr/resume");
          }
        }
      });
    }
    this.ifEdit = !!this.$route.params.id;
    this.init().then(() => {
      if (this.ifEdit) {
        this.getEditValue();
      }
    });
  },
  methods: {
    async getEditValue() {
      await axios({
        method: "GET",
        url: `${this.baseApi}/getcvById/${this.$route.params.id}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
      })
        .then((json) => {
          this.getEditItems(json.data.data);
          // Force Vue to update after setting vacancy
          this.$nextTick(() => {
            this.$forceUpdate();
          });
        })
        .catch((error) => console.log(error, "error"));
    },
    getEditItems(item) {
      item.map((item) => {
        // Find matching vacancy object from jobvacancyoption array
        // Handle different field names: jobvacancy, vacancy, vacancyid
        let vacancyData = item.jobvacancy || item.vacancy || null;
        let vacancyId = null;
        
        if (vacancyData) {
          // Handle array format (e.g., [{}])
          if (Array.isArray(vacancyData) && vacancyData.length > 0) {
            vacancyData = vacancyData[0];
          }
          // Extract ID from object or use direct value
          vacancyId = vacancyData.id || vacancyData;
        } else if (item.vacancyid) {
          // Handle direct vacancyid field
          vacancyId = item.vacancyid;
        }
        
        // Find matching vacancy object from jobvacancyoption array
        if (vacancyId && this.jobvacancyoption && this.jobvacancyoption.length > 0) {
          const matchedVacancy = this.jobvacancyoption.find(
            (vacancy) => vacancy.id === vacancyId || vacancy.id === parseInt(vacancyId)
          );
          if (matchedVacancy) {
            this.vacancyid = matchedVacancy;
          } else if (vacancyData && typeof vacancyData === 'object' && vacancyData.name) {
            // If no match found but we have the full object, use it
            this.vacancyid = vacancyData;
          } else {
            this.vacancyid = "";
          }
        } else {
          this.vacancyid = "";
        }
        
        this.name = item.name;
        this.attachment = item.attachment;
        this.status = item.status;
        this.at = item.at;
        this.taluka = item.taluka;
        this.city = item.district;
        this.pincode = item.pincode;
        this.phone = item.phone;
        this.state = item.state;
        this.area = item.area;
        this.email = item.email;
        // this.clickPincode()
        // this.clickPerPincode()
        this.handleCity();
        this.handleArea();
      });
    },
    async init() {
      await this.getVacancy();
      await this.getState();
    },
    async handleArea() {
      const reportauthority = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
        url: `${this.baseApi}/getAreaByCity`,
        data: {
          City: this.city,
        },
      };
      await axios(reportauthority)
        .then((response) => {
          this.areaOption = response.data.data;
        })
        .catch((error) => console.log(error, "error"));
    },
    clickArea(e) {
      if (this.fromState == true) {
        this.handleArea();
      }
      //   this.areaOption = []
      // this.StateData.map((item) => {
      //   if (item.City == e) {
      //     this.areaOption.push(item.PostOfficeName)
      //   }
      // })
    },
    handlePincode() {
      if (this.fromState == true) {
        this.pincode = this.area.Pincode;
      }
    },
    async handleCity() {
      this.cityOption = [];
      this.areaOption = [];
      this.fromState = true;
      const reportauthority = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
        url: `${this.baseApi}/getCityByState`,
        data: {
          State: this.state,
        },
      };
      await axios(reportauthority)
        .then((response) => {
          this.cityOption = response.data.data;
        })
        .catch((error) => console.log(error, "error"));
    },
    async getState() {
      const reportauthority = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
        url: `${this.baseApi}/getState`,
      };
      await axios(reportauthority)
        .then((response) => {
          this.stateOptions = response.data.data;
        })
        .catch((error) => console.log(error, "error"));
    },

    async clickPincode() {
      this.area = "";
      this.city = "";
      this.state = "";
      this.areaOption = [];
      this.cityOption = [];
      const regex = new RegExp(/^[0-9]{6}$/);
      if (regex.test(this.pincode)) {
        this.fromState = false;
        const reportauthority = {
          method: "post",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.accessToken}`,
          },
          url: `${this.baseApi}/pincode`,
          data: {
            Pincode: `${this.pincode}`,
          },
        };
        await axios(reportauthority)
          .then((response) => {
            this.cityOption = [];
            this.StateData = response.data.data;
            this.areaOption = response.data.data;
            this.state = response.data.data[0];
            const resArr = [];
            response.data.data.filter(function (item) {
              const i = resArr.findIndex((x) => x.City == item.City);
              if (i <= -1) {
                resArr.push(item);
              }
              return null;
            });
            this.cityOption = resArr;
          })
          .catch((error) => console.log(error, "error"));
      }
    },
    async getVacancy(id) {
      if (id !== undefined) {
        this.id = id;
      }
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.accessToken}`,
        },
        url: `${this.baseApi}/getjobvacancy`,
      };
      await axios(requestOptions)
        .then((response) => {
          this.jobvacancyoption = response.data.data;
        })
        .catch((error) => console.log(error, "error"));
    },
    onClickBack() {
      this.$router.push("/hr/resume");
    },
    handleMobileKeypress(event) {
      // Allow only numeric keys (0-9) and control keys (backspace, delete, tab, etc.)
      const charCode = event.which ? event.which : event.keyCode;
      // Allow control keys: backspace (8), delete (46), tab (9), escape (27), enter (13)
      // Allow navigation keys: left arrow (37), right arrow (39), home (36), end (35)
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        event.preventDefault();
        return false;
      }
      return true;
    },
    handleMobileInput(event) {
      // Remove all non-numeric characters immediately
      const numericValue = event.target.value.replace(/\D/g, '');
      // Limit to 10 digits
      const limitedValue = numericValue.slice(0, 10);
      // Update the model with only digits
      this.phone = limitedValue;
      // Update the input field value immediately
      this.$nextTick(() => {
        event.target.value = limitedValue;
      });
    },
    async handleFile(e, type) {
      this.flag = true;
      const accessToken = localStorage.getItem("accessToken");
      const baseApi = process.env.VUE_APP_APIENDPOINT;
      const formData = new FormData();
      formData.append("image", e);
      formData.append("type", type);

      const requestoption = {
        method: "POST",
        headers: {
          "Contant-type": "multipart/form-data",
          Authorization: `Bearer ${accessToken}`,
        },
        data: formData,
        url: `${baseApi}/attachment`,
      };
      await axios(requestoption)
        .then((response) => {
          this.flag = false;

          this.attachment = process.env.VUE_APP_IMAGE_PATH + response.data.attachment;
        })
        .catch((error) => {
          this.flag = false;
          console.log(error, "error");
        });
    },
    submitForm(e) {
      const data = {
        vacancyid: this.vacancyid?.id,
        name: this.name,
        attachment: this.attachment,
        status: this.status,
        at: this.at,
        taluka: this.taluka,
        pincode: this.pincode,
        phone: this.phone,
        email: this.email,
        area: this.area.PostOfficeName,
        state: this.state.State,
        district: this.city.City,
      };
      // var ifEdit = this.$route.params.id ? true : false;
      this.$refs.simpleRules.validate().then(async (success) => {
        if (success == false) {
          this.$swal({
            title: "Warning",
            timer: 5000,
            text: "Plese Fill the All Field",
            icon: "warning",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });
        }
        if (success) {
          this.flag = true;
          const accessToken = localStorage.getItem("accessToken");
          const baseApi = process.env.VUE_APP_APIENDPOINT;
          await axios({
            method: `${this.ifEdit ? "put" : "post"}`,
            url: this.ifEdit
              ? `${baseApi}/cv/${this.$route.params.id}`
              : `${baseApi}/cv`,
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${accessToken}`,
            },
            data: JSON.stringify(data),
          })
            .then((json) => {
              this.flag = false;

              this.$swal({
                title: "Submited",
                text: json.data.message
                  ? `${json.data.message}`
                  : json.data.success
                    ? `${json.data.success}`
                    : "Update SuccessFully",
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                buttonsStyling: false,
              });
              this.$router.push("/hr/resume");
            })
            .catch((error) => {
              this.flag = false;

              this.$swal({
                title: "Error!",
                text: `${error}`,
                icon: "error",
                timer: 5000,
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
  },
};
</script>
